module.exports = __webpack_public_path__ + "img/head_tips.50bcd947.png";